export var CacheStoreTag;
(function (CacheStoreTag) {
    CacheStoreTag["Persistent"] = "persistent";
    CacheStoreTag["Temp"] = "temp";
})(CacheStoreTag || (CacheStoreTag = {}));
//# sourceMappingURL=CacheStoreTag.js.map